/*
 * Copyright (c) 2021. American Express Company
 */

import $ from 'jquery';
import React, { Component, ReactComponentElement } from 'react';

// models and services
import { CardIconViewModel } from 'src/types/view-models/card-icon.view.model';
import CardService from '../../services/card.service';

// stylesheets
import styles from './CardIcon.module.scss';

export default class CardIcon extends Component<CardIconViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <div className={this.getClasses()}>
                {!this.props.card.hash ? (
                    this.props.children
                ) : (
                    <img src={CardService.getPhotoUrl(this.props.card)} className="image" alt="card" />
                )}
                {/*
                <ImageUpload
                    className='imageUploader'
                    customRender={true}
                    onSubmit={async (blob: Blob, fileUrl: string) => {
                        await CardService.postPhoto(this.props.card.id, blob);
                        if (this.props.handleUpdateCard) {
                            const card = await CardService.getCardPayload(this.props.card);
                            this.props.handleUpdateCard(card, null, true);
                        }
                    }}
                    onClick={this.startUpload.bind(this)}
                >
                    <div className='background' />
                    <div className='upload'>
                        <IconUpload className='uploadIcon' />
                    </div>
                </ImageUpload> */}
            </div>
        );
    }

    private startUpload(): void {
        // pick an image unless already picking an image
        if (!$('.image-crop-dialog')[0]) {
            $('.imageUploader .imageUpload').click();
        }
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        if (this.props.className) {
            classes.push(this.props.className);
        }

        classes.push(styles.cardIcon);

        return classes.join(' ');
    }
}
